import type { InjectionKey, Ref } from 'vue'
import { inject, provide } from 'vue'

/**
 * Where the viewer of a chat's Word documents and spreadsheets docks beside
 * the chat (spec `chat-office-files.md`, the viewer of the F6 follow-ups): a
 * page that lays the chat out between columns of its own, as the frontoffice
 * chat page does with its sidebar, gives an element for the viewer to take
 * the page's whole height, outside the chat's header and footer. Where
 * nothing is provided (the widget, the playground) the viewer stays a panel
 * inside the chat.
 */
export const ChatFilePreviewDockKey: InjectionKey<
    Readonly<Ref<HTMLElement | null | undefined>>
> = Symbol('ChatFilePreviewDock')

/** Gives the chats below the element their viewer docks in. */
export function provideChatFilePreviewDock(
    dock: Readonly<Ref<HTMLElement | null | undefined>>,
) {
    provide(ChatFilePreviewDockKey, dock)
}

/** The element the viewer docks in, when the page gives one. */
export function useChatFilePreviewDock() {
    return inject(ChatFilePreviewDockKey, undefined)
}
